// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-notifications-container {
  padding: 10px;
  border-bottom: 1px solid #c1c1c1;
}
.no-notifications-container p.message {
  font-size: 0.9em;
  font-weight: bold;
  margin: 5px 0;
}`, "",{"version":3,"sources":["webpack://./src/app/view/page/notifications/notifications.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,gCAAA;AACJ;AAAI;EACI,gBAAA;EACA,iBAAA;EACA,aAAA;AAER","sourcesContent":[".no-notifications-container {\n    padding: 10px;\n    border-bottom: 1px solid #c1c1c1;\n    p.message {\n        font-size: 0.9em;\n        font-weight: bold;\n        margin: 5px 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
